class PersistentStorage {
    getItem(name, fallback = null) {
        const json = window.localStorage.getItem(name);
        if (!json) return fallback;

        try {
            const parsed = JSON.parse(json);
            return parsed.value ? parsed.value : fallback;
        } catch {
            return fallback;
        }
    }

    setItem(name, value) {
        window.localStorage.setItem(name, JSON.stringify({ value }));
    }

    removeItem(name) {
        window.localStorage.removeItem(name);
    }

    clear() {
        window.localStorage.clear();
    }
}

export default new PersistentStorage();
